import { render, staticRenderFns } from "./ProductSelectorFetch.vue?vue&type=template&id=bfb8b74c&scoped=true&"
import script from "./ProductSelectorFetch.vue?vue&type=script&lang=js&"
export * from "./ProductSelectorFetch.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelectorFetch.vue?vue&type=style&index=0&id=bfb8b74c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb8b74c",
  null
  
)

export default component.exports